import { render, staticRenderFns } from "./Robe.vue?vue&type=template&id=2e8cd647"
import script from "./Robe.vue?vue&type=script&lang=js"
export * from "./Robe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports